import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const HISTORICAL_LAYERS: Record<string, { url: string; params: L.WMSOptions }> = {
  '1950–1965 Aerial': {
    url: 'https://data.geopf.fr/wms-r',
    params: {
      layers: 'ORTHOIMAGERY.ORTHOPHOTOS.1950-1965',
      format: 'image/png',
      transparent: true,
    },
  },
  'SCAN 1950': {
    url: 'https://data.geopf.fr/wms-r',
    params: {
      layers: 'GEOGRAPHICALGRIDSYSTEMS.MAPS.SCAN50.1950',
      format: 'image/png',
      transparent: true,
    },
  },
  '1820–1866 Army Map': {
    url: 'https://data.geopf.fr/wms-r',
    params: {
      layers: 'GEOGRAPHICALGRIDSYSTEMS.ETATMAJOR40',
      format: 'image/png',
      transparent: true,
    },
  },
};

export class HistoricalMapControl extends L.Control {
  private map: L.Map | null = null;
  private currentLayer: L.Layer | null = null;

  onAdd(map: L.Map): HTMLElement {
    this.map = map;

    const container = L.DomUtil.create('div', 'leaflet-control-historical');
    Object.assign(container.style, {
      backgroundColor: 'white',
      padding: '12px',
      borderRadius: '8px',
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
      fontFamily: 'sans-serif',
      fontSize: '14px',
    });

    const label = L.DomUtil.create('label', '', container);
    label.htmlFor = 'historical-map-select';
    label.textContent = 'Historical Maps';
    label.style.fontWeight = 'bold';
    label.style.display = 'block';
    label.style.marginBottom = '6px';

    const select = L.DomUtil.create('select', '', container) as HTMLSelectElement;
    select.id = 'historical-map-select';
    Object.assign(select.style, {
      width: '100%',
      padding: '6px',
      borderRadius: '4px',
      border: '1px solid #ccc',
    });

    this.populateDropdown(select);

    select.addEventListener('change', (e) => {
      const selected = (e.target as HTMLSelectElement).value;
      this.updateLayer(selected);
    });

    return container;
  }

  private populateDropdown(select: HTMLSelectElement) {
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.text = 'Select historical layer';
    select.appendChild(defaultOption);

    for (const label in HISTORICAL_LAYERS) {
      const option = document.createElement('option');
      option.value = label;
      option.text = label;
      select.appendChild(option);
    }
  }

  private updateLayer(selected: string) {
    if (!this.map) return;

    if (this.currentLayer) {
      this.map.removeLayer(this.currentLayer);
      this.currentLayer = null;
    }

    const config = HISTORICAL_LAYERS[selected];
    if (config) {
      this.currentLayer = L.tileLayer.wms(config.url, {
        ...config.params,
        version: '1.3.0',
        crs: L.CRS.EPSG3857,
        attribution: '© IGN France',
      });
      this.currentLayer.addTo(this.map);
    }
  }
}
